import { CardContent as MuiCardContent } from "@mui/material";

export const CardContent = (props: any) => {
    return<MuiCardContent {...props}>
    </MuiCardContent>
  };
